import { render, staticRenderFns } from "./EditSalesStaffRelativeRegionsModal.vue?vue&type=template&id=787b5243&scoped=true"
import script from "./EditSalesStaffRelativeRegionsModal.vue?vue&type=script&lang=ts"
export * from "./EditSalesStaffRelativeRegionsModal.vue?vue&type=script&lang=ts"
import style0 from "./EditSalesStaffRelativeRegionsModal.vue?vue&type=style&index=0&id=787b5243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b5243",
  null
  
)

export default component.exports